import React from "react";

import styles from "./Graph.module.scss";

export default function ToolsRemote () {
    const svg = `
<svg width="915px" height="947px" viewBox="0 0 915 947" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g>
            <g transform="translate(305.000000, 0.000000)">
                <circle fill="#7B83EB" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="26" font-weight="bold" line-spacing="30" fill="#FFFFFF">
                    <tspan x="94.3540039" y="65.2099609">Microsoft</tspan>
                    <tspan x="114.1142578" y="95.2099609">Teams</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="51.3452148" y="132">Lancé en 2016 par Microsoft. </tspan>
                    <tspan x="53.2348633" y="152">Le service s'intègre à la suite </tspan>
                    <tspan x="29.9768066" y="172">Microsoft 365 en remplacement de </tspan>
                    <tspan x="84.934082" y="192">Skype for Business.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="56.5087891" y="233">250 millions d’utilisateurs </tspan>
                    <tspan x="94.1589355" y="253">actifs mensuels</tspan>
                </text>
            </g>
            <g transform="translate(0.000000, 150.000000)">
                <circle fill="#2E8CFF" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="38" font-weight="bold" fill="#FFFFFF">
                    <tspan x="99.3129883" y="99">Zoom</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="52.2460938" y="152">Lancé en 2013 par Eric Yuan.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="42.7758789" y="207">300 millions de participants à </tspan>
                    <tspan x="57.7758789" y="227">des réunions chaque jour</tspan>
                </text>
            </g>
            <g transform="translate(0.000000, 489.000000)">
                <circle fill="#02A151" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="32" font-weight="bold" fill="#FFFFFF">
                    <tspan x="52.6328125" y="101">Google Meet</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="42.9956055" y="154">Lancé en 2017 par Google pour </tspan>
                    <tspan x="52.3486328" y="174">remplacer Google Hangouts.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="56.5087891" y="229">100 millions d’utilisateurs </tspan>
                    <tspan x="112.513428" y="249">quotidiens</tspan>
                </text>
            </g>
            <g transform="translate(610.000000, 150.000000)">
                <circle fill="#611E69" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="34" font-weight="bold" fill="#FFFFFF">
                    <tspan x="108.397949" y="73">Slack</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="59.7827148" y="114">Lancé en 2014 par Stewart </tspan>
                    <tspan x="54.2932129" y="134">Butterfield, Eric Costello, Cal </tspan>
                    <tspan x="35.078125" y="154">Henderson et Serguei Mourachov </tspan>
                    <tspan x="50.6530762" y="174">et rachetée par Salesforce en </tspan>
                    <tspan x="95.9790039" y="194">décembre 2020.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="60.7897949" y="237">12 millions d’utilisateurs </tspan>
                    <tspan x="90.0024414" y="257">actifs quotidiens</tspan>
                </text>
            </g>
            <g transform="translate(610.000000, 489.000000)">
                <circle fill="#00BCEB" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="32" font-weight="bold" fill="#FFFFFF">
                    <tspan x="53.4296875" y="102">Cisco Webex</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="30.9399414" y="154">Lancé en 1996 et racheté par Cisco </tspan>
                    <tspan x="122.591553" y="174">en 2005.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="42.7758789" y="219">300 millions de participants à </tspan>
                    <tspan x="57.7758789" y="239">des réunions chaque jour</tspan>
                </text>
            </g>
            <g transform="translate(318.000000, 642.000000)">
                <circle fill="#4526CE" cx="152.5" cy="152.5" r="152.5"></circle>
                <text font-family="OpenSans-Bold, Open Sans" font-size="32" font-weight="bold" fill="#FFFFFF">
                    <tspan x="67.5859375" y="88">Workplace</tspan>
                </text>
                <text font-family="OpenSans-Regular, Open Sans" font-size="15" font-weight="normal" fill="#FFFFFF">
                    <tspan x="28.8708496" y="131">Lancé par Meta (Facebook) en 2016</tspan>
                    <tspan x="24.8937988" y="151">L’application se rapproche de Teams </tspan>
                    <tspan x="36.2097168" y="171">et sa disponibilité sur le dispositif </tspan>
                    <tspan x="36.652832" y="191">vidéo Meta Portal est imminente.</tspan>
                </text>
                <text font-family="OpenSans-Bold, Open Sans" font-size="15" font-weight="bold" fill="#FFFFFF">
                    <tspan x="87.7209473" y="235">Plus de 7 millions</tspan>
                    <tspan x="81.887207" y="255">d'abonnés payants</tspan>
                </text>
            </g>
        </g>
    </g>
</svg>`;

    return (
        <div className={styles.Mono}>
            <div dangerouslySetInnerHTML={{__html: svg}} className={[styles.Graph, styles.Big].join(' ')}/>
        </div>
    )
}
